import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { BRAND_NAME } from '../lib/brand';
import { Brand } from './site-header';

/**
 * Frame for the sign-in, sign-up, and password pages: the wordmark, one
 * narrow centered column, and nothing else competing with the form.
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="auth-shell">
      <Brand />
      <main className="auth-main">{children}</main>
      <p className="auth-shell-foot">
        {BRAND_NAME} does not provide investment advice.{' '}
        <Link className="text-link" to="/terms">
          Terms
        </Link>
      </p>
    </div>
  );
}
